// src/services/paymentApi.js
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Function to handle common fetch logic and error handling
async function handleResponse(response) {
    const contentType = response.headers.get('content-type');
    let data;
    if (contentType && contentType.includes('application/json')) {
        data = await response.json();
    } else {
        data = { error: `Unexpected response type: ${contentType}`, responseText: await response.text() };
    }

    if (!response.ok) {
        const error = new Error(data.error || data.message || `HTTP error! status: ${response.status}`);
        error.status = response.status;
        error.data = data;
        throw error;
    }
    return data;
}

// Create Razorpay order. `couponCode` is forwarded as a top-level field so the
// backend can validate + reserve the coupon atomically against the new order.
export const createRazorpayOrder = async (token, amount, purchaseType, meta = {}, couponCode = null) => {
    const body = { amount, purchase_type: purchaseType, meta };
    if (couponCode) body.coupon_code = couponCode;
    const response = await fetch(`${API_URL}/payment_integration/create-order`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
    return handleResponse(response);
};

// Verify Razorpay payment
export const verifyRazorpayPayment = async (token, razorpayOrderId, razorpayPaymentId, razorpaySignature) => {
    const response = await fetch(`${API_URL}/payment_integration/verify-payment`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            razorpay_order_id: razorpayOrderId,
            razorpay_payment_id: razorpayPaymentId,
            razorpay_signature: razorpaySignature
        })
    });
    return handleResponse(response);
};

// Load Razorpay script dynamically
export const loadRazorpayScript = () => {
    return new Promise((resolve) => {
        if (window.Razorpay) {
            resolve(true);
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
};

// Get user balance
export const getUserBalance = async (token) => {
    const response = await fetch(`${API_URL}/payment_integration/user-balance`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
    return handleResponse(response);
};

